/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const LineChart = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M3 3v18h18" }],
    ["path", { d: "m19 9-5 5-4-4-3 3" }]
  ]
];

export { LineChart as default };
//# sourceMappingURL=line-chart.js.map
